module.exports = "https://r.nearpod.com/assets/media/image/selected-icon-3aaf7ec6bcb8b5984f6d9355d696279f.svg";